import React from "react";
import Blog_48 from "../component/Blog_48";
function Blog_48_container() {
  return <Blog_48 />;
}

export default Blog_48_container;
